import messenger from '@modules/messenger'

const classname = {
  onError: 'has-error',
  onSuccess: 'has-success',
  dispatchLoader: 'o-button-loading'
}

const dispatch = (context, body, api, getLoader = true) => {
  if (getLoader) {
    getDispatchLoader({ context, status: 'pending' })
  }

  return window.fetch(api, {
    mode: 'cors',
    method: 'POST',
    body: new URLSearchParams(body),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
    .then((response) => {
      if (getLoader) getDispatchLoader({ context })
      return response.json()
    })
    .catch(() => {
      messenger.show({ context })
      if (getLoader) getDispatchLoader({ context })
    })
}

const getDispatchLoader = ({ context, status, target = context.querySelector('button[type="submit"]') }) => {
  if (status === 'pending' || status === 'onrecaptcha') {
    if (context.querySelector(`.${classname.dispatchLoader}`)) return

    const bullets = document.createElement('span')
    bullets.classList.add(classname.dispatchLoader)
    bullets.innerHTML = `
      <span class="mq"></span>
      <span class="mg"></span>
      <span class="mq"></span>
    `

    status === 'pending'
      ? target.disabled = true
      : target.classList.add('is-disabled')

    target.insertAdjacentElement('afterbegin', bullets)
  } else {
    const bullets = context.querySelector(`.${classname.dispatchLoader}`)

    if (bullets) {
      setTimeout(() => {
        target.disabled = false
        target.classList.remove('is-disabled')
        bullets.remove()
      }, 500)
    }
  }
}

export { dispatch, getDispatchLoader }
